import React from 'react';
import { motion } from 'framer-motion';

const Services: React.FC = () => {
  const services = [
    {
      title: 'Custom Website Development',
      description:
        'Bespoke websites that reflect your unique brand identity. From stunning landing pages to complex corporate portals, we create digital experiences that convert visitors into customers and leave lasting impressions.',
      icon: '🎨'
    },
    {
      title: 'Web Application Development',
      description:
        'Powerful web applications with intuitive dashboards, seamless user authentication, and robust APIs. Built for scalability, security, and performance that grows with your business needs.',
      icon: '⚡'
    },
    {
      title: 'E-Commerce Solutions',
      description:
        'Complete online stores with secure payment gateways, inventory management, and mobile-optimized shopping experiences. Turn browsers into buyers with conversion-focused design.',
      icon: '🛍️'
    },
    {
      title: 'UI/UX Design Excellence',
      description:
        'User-centered design that delights and engages. We craft interfaces that are not just beautiful, but intuitive, accessible, and optimized for maximum user satisfaction and business results.',
      icon: '✨'
    },
    {
      title: 'Full-Stack Development',
      description:
        'End-to-end development expertise covering frontend magic and backend power. We build secure, scalable systems with modern architectures that future-proof your digital presence.',
      icon: '🚀'
    },
    {
      title: 'Digital Transformation',
      description:
        'Complete digital makeovers that modernize your business operations. From legacy system migrations to cutting-edge web applications, we ensure your digital transformation delivers measurable ROI.',
      icon: '🔄'
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section id="services" className="services">
      <motion.h2
        className="wow fadeInUp"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Comprehensive Digital Solutions
      </motion.h2>
      <p className="section-subtitle wow fadeInUp" data-wow-delay="0.2s">
        From stunning websites to powerful web applications, we deliver cutting-edge digital solutions that drive results. Each project is crafted with precision, creativity, and technical excellence to exceed your expectations.
      </p>
      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className={`service-card wow fadeInUp`}
            data-wow-delay={`${0.3 + index * 0.1}s`}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
